import React from 'react'
import image from '../../assets/android-chrome-192x192.png'

export const PageHead = ({ title }) => <>
  <title>Shivoo{title ? ' - ' + title : ''}</title>
  <link rel="icon" href={image} type="image/png" />
  <link rel="preload" href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400..700&display=swap" />
  <link rel="preload" href="https://use.typekit.net/ebm5dok.css" as="style" />
  <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400..700&display=swap" rel="stylesheet" />
  <link href="https://use.typekit.net/ebm5dok.css" rel="stylesheet" />
  <meta name="description" content="Discuss, discover and debate your team's performance and capability in real time with a unique assessment tool. Track progress, map improvements, celebrate milestones, and compare with teams worldwide." />
</>